/**
 * Navigation Bar Component
 * 
 * Appears on all authenticated pages
 * Features:
 * - User greeting with first name
 * - Profile link
 * - Logout button
 */

import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { User, LogOut, Home } from 'lucide-react';

const Navigation = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  return (
    <nav className="bg-white border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Left side - Home button (only show if not on home page) */}
          <div>
            {location.pathname !== '/' && (
              <Button
                onClick={() => navigate('/')}
                variant="ghost"
                className="hover:bg-slate-100"
              >
                <Home className="mr-2 h-4 w-4" />
                Dashboard
              </Button>
            )}
          </div>

          {/* Right side - User info and actions */}
          <div className="flex items-center gap-3">
            {/* User greeting */}
            <span className="text-slate-700 hidden sm:block">
              Hello, <strong>{user?.first_name}</strong>
            </span>

            {/* Profile button */}
            <Button
              onClick={() => navigate('/profile')}
              variant="outline"
              className="hover:bg-slate-100"
            >
              <User className="mr-2 h-4 w-4" />
              Profile
            </Button>

            {/* Logout button */}
            <Button
              onClick={handleLogout}
              variant="outline"
              className="hover:bg-red-50 hover:text-red-600 hover:border-red-300"
            >
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
